import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchPublicPdf } from "@services/export";
import { useError } from "@context/ErrorContext";
import logger from "@utils/logger";

export const PublicPDFViewer = () => {
  const { fileId } = useParams();
  const [pdfUrl, setPdfUrl] = useState(null);
  const objectUrlRef = useRef(null);
  const { showError } = useError();

  useEffect(() => {
    const fetchAndSetPdf = async () => {
      try {
        const response = await fetchPublicPdf(fileId, showError);
        if (response) {
          objectUrlRef.current = response;
          setPdfUrl(response);
        }
      } catch (error) {
        logger.error(
          `Error exporting PDF for file ID: ${fileId}: ${error.message}`
        );
        showError("There was an issue loading the PDF. Please try again later.");
      }
    };

      fetchAndSetPdf();
    return () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
      }
    };
  }, [fileId]);

  if (!pdfUrl) return <div>Loading PDF...</div>;

  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <iframe
        src={pdfUrl}
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="PDF Viewer"
      />
    </div>
  );
};
